import { ThemeVariant } from "../types";

/**
 * Viewer module constants shared across API, wrapper, and bridge.
 */
export const VIEWER_EXPRESS_CONTAINER_ID = "viewer-express-container";
/** Legacy adapter React root wrapper — must not reuse VIEWER_EXPRESS_CONTAINER_ID. */
export const VIEWER_EXPRESS_LEGACY_ROOT_CLASS = "viewer-express-legacy-root";
export const DEFAULT_THEME_VARIANT: Partial<ThemeVariant> = { css: "" };
